import { useCallback, useEffect } from 'react'
import WBImage from '@assets/wb-image.png'
import { Assets } from '@nexds/web'
import { useTheme } from 'styled-components'

import {
  BannerActionButton,
  Body,
  Box,
  CloseButton,
  Content,
  Header,
  NewsBannerContainer,
  StepItem,
  StepsContainer,
  Title
} from './NewsBanner.styles'

import { useI18n } from '@/presentation/hooks/useI18n'
import { BackdropImperativeInterface } from '@/presentation/interfaces/BackdropImperativeInterface'
import { openDrawer } from '@/presentation/router/DrawerRouter'
import { RouterPaths } from '@/presentation/router/RouterPathsMapper'
import { appZIndex } from '@/presentation/utils/zIndexMapper'

interface NewsBannerProps {
  onClose: () => void
}

function NewsBanner(props: NewsBannerProps) {
  const { onClose } = props
  const theme = useTheme()
  const { t } = useI18n() // TODO: i18n in all texts

  useEffect(() => {
    setTimeout(() => {
      BackdropImperativeInterface.show(appZIndex.BANNER_DESKTOP, 0.5, onClose)
    }, 100)

    return () => {
      BackdropImperativeInterface.hide()
    }
  }, [])

  const handleActionClick = useCallback(() => {
    onClose()
    openDrawer(RouterPaths.WEIGHT_AND_BALANCE)
  }, [])

  return (
    <NewsBannerContainer>
      <Header>
        <Box />
        <CloseButton onClick={onClose}>
          <Assets.Close2 size={'sm'} color={theme.colors.secondaryL3} />
        </CloseButton>
      </Header>
      <Body>
        <img src={WBImage} alt="WB Image" width={'40%'} />
        <Content>
          <Title>{'Novidade em testes! ⚖️✈️'}</Title>
          <p>
            A funcionalidade de <strong>Peso e Balanceamento</strong> está disponível em fase de testes.
          </p>
          <p>Com ela, você pode:</p>
          <StepsContainer>
            <StepItem>
              <strong>cadastrar perfis de peso e balanceamento</strong>
            </StepItem>
            <StepItem>
              <strong>preencher a ficha de P&B dos seus voos</strong>
            </StepItem>
          </StepsContainer>
          <p>Encontrou algo inesperado? Nos avise para podermos ajustar e aprimorar rapidamente.</p>
          <p>
            <strong>Feedbacks sobre o fluxo, críticas e sugestões de melhoria</strong> são muito bem-vindos.
          </p>

          <p>Sua participação é essencial para a evolução dessa feature!</p>
          <BannerActionButton onClick={handleActionClick}>{'Testar Peso e Balanceamento ⚖️'}</BannerActionButton>
        </Content>
      </Body>
    </NewsBannerContainer>
  )
}

export { NewsBanner }
